import { RESULT_TYPE } from '@savgroup-front-common/types';

export const SEARCH_INITIAL_PAGE_SIZE = 3;
export const SEARCH_SHOW_MORE_STEP = 15;

const buildSearchPageSizes = ({
  showMoreCountByResultType,
  resultTypes,
}: {
  showMoreCountByResultType: Record<RESULT_TYPE, number>;
  resultTypes: RESULT_TYPE[];
}): Partial<Record<RESULT_TYPE, number>> => {
  return resultTypes.reduce<Partial<Record<RESULT_TYPE, number>>>(
    (pageSizesByResultType, type) => {
      return {
        ...pageSizesByResultType,
        [type]:
          SEARCH_INITIAL_PAGE_SIZE +
          showMoreCountByResultType[type] * SEARCH_SHOW_MORE_STEP,
      };
    },
    {},
  );
};

export default buildSearchPageSizes;
